import { render, staticRenderFns } from "./sidebarGroupChatSM.vue?vue&type=template&id=09c09e25&scoped=true"
import script from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
export * from "./sidebarGroupChatSM.vue?vue&type=script&lang=js"
import style0 from "./sidebarGroupChatSM.vue?vue&type=style&index=0&id=09c09e25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c09e25",
  null
  
)

export default component.exports